import { PackagePanelController } from '../controller/PackagePanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PackageActionContext } from '../../common/types/PackageActionContext';
import { PackageData, PackagePanelType, PackageType } from '../../packagesGrid/types';
import { KitTypes } from '../../downloadKitButtonSelector/constants';

export class PackagePanelWebComponent extends BaseWebComponentElement {
  public controller!: PackagePanelController;
  private packageType: PackageType;
  private packageData: PackageData;
  private _panelType: PackagePanelType;
  private _selectedKitType: KitTypes | null = null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackagePanelController,
    });
  }

  public getPackageType(): PackageType {
    return this.packageType;
  }

  public setPackageType(type: PackageType) {
    this.packageType = type;
  }

  getPackageData(): PackageData {
    return this.packageData;
  }

  public get selectedKitType(): KitTypes | null {
    return this._selectedKitType;
  }

  public set selectedKitType(selectedKitType: KitTypes | null) {
    this._selectedKitType = selectedKitType;
  }
  public setPackageData(packageData: PackageData): void {
    this.packageData = packageData;
  }

  public get formContext(): PackageActionContext {
    const context = this.getAttribute('context');

    if (!PackageActionContext.isValid(context)) {
      throw new Error(`PackagePanel context not valid: ${context}`);
    }

    return context as PackageActionContext;
  }

  public set formContext(context: PackageActionContext) {
    this.setAttribute('context', context);
  }

  public get panelType(): PackagePanelType {
    return this._panelType;
  }

  public set panelType(panelType: PackagePanelType) {
    this._panelType = panelType;
  }

  public get isStaging(): boolean {
    return this.panelType === PackagePanelType.STAGING;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.hasUnsavedChanges;
  }

  public toggleVisibilityRemoveCompetitorInfo(isVisible: boolean): void {
    this.controller.view.toggleVisibilityRemoveCompetitorInfo(isVisible);
  }
}
